import Actions                   from 'Redux/Actions';
import { EventTicketRepository } from 'Domain/Repositories';
import { ofType }                from 'redux-observable';
import { from }                  from 'rxjs';
import { mergeMap, catchError }  from 'rxjs/operators';
import { TEpic }                 from 'Redux/Config';
import { message }               from 'antd';

export const updateEventTicketEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateEventTicketRequest.type),
    mergeMap(action => from(EventTicketRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((eventTicket) => {
          message.success('Die Speicherung des Event Tickets erfolgreich.');

          return from([
            Actions.updateEventTicketSuccess({ eventTicket }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateEventTicketFailure({ error })
          ]);
        })
      )
    ),
  );
};
